
import { of, Observable } from 'rxjs';
import { catchError, map, share, switchMap, withLatestFrom} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DigitalSubscriptionAction } from './digital-subscription.action';
import { AppState } from '../../interfaces/app-state.interface';
import { HttpService } from '../../services/http/http.service';
import { UsersState } from '../users/users.reducer';
import { SettingsService } from '../../services/settings/settings.service';
import { StocksApiService } from '../../services/stocks/stocks-api.service';

@Injectable()
export class DigitalSubscriptionEffects {

    /**
     * Busca as subscriptions que o usuário assinou
     */
    getPurchase$ = createEffect(() => this.actions$
        .pipe(
            ofType(DigitalSubscriptionAction.getPurchase),
            withLatestFrom(this.store.select((authStore) => authStore.authentication)),
            switchMap(([action, userStore]) => {

                const digitalPurshasesUri = 'product-subscription/list-products-by-user';
                
                const isLogged = !!(userStore.currentUser && userStore.currentUser.token);
                if (!isLogged) return of({ type: DigitalSubscriptionAction.getPurchaseSuccess, payload: {} });
                
                return this.stocksApiService.get(digitalPurshasesUri)
                    .pipe(
                        map((result: any) => {
                            if (result.data) {
                                return { type: DigitalSubscriptionAction.getPurchaseSuccess, payload: result.data };
                            }
                            return { type: DigitalSubscriptionAction.getPurchaseError, payload: result };
                        }),
                        catchError((error) => {
                            return of({ type: DigitalSubscriptionAction.getPurchaseError, payload: error });
                        }),
                    );
            }),
            share(),
        ));

    private getDigitalPurshasesUri: string;

    constructor(
        private actions$: Actions,
        private store: Store<AppState>,
        private httpService: HttpService,
        private settingService: SettingsService,
        private stocksApiService: StocksApiService
    ) {}
}
